import {royale_viewSetupResponsive} from "./jsinc/_viewResponsive";

window.cj_offsetX = -1;
(function ($) {

  let menu_hoffset = 0;
  let menu_height = 0;


  $.royale = function () {
    let
      _body = $('body')
    ;

    const _royaleBackgroundCon = $('.royale--background-con').eq(0)
    ;

    init();

    // INIT FUNCTION
    function init() {


      setTimeout(function () {

        _body.addClass('royale-inited');
      }, 100);


      var logo = $(".royale-logo"),
        nav = $(".menu-left nav").eq(0),
        topNav = logo.height() + parseInt(logo.css("margin-top"), 10) + parseInt(nav.css("margin-top"), 10)
      ;


      royale_viewSetupResponsive();

      topNav = nav.offset().top;
      if (_body.hasClass('admin-bar')) {
        topNav -= 32;
      }
      menu_hoffset = $('nav > div').height() + parseInt($('nav > div').offset().top);
      menu_height = parseInt($('nav > div').height());


      $('.searchform').each(function () {
        var _t = $(this);
        if (_t.find('.dashicons-search').length == 0) {

          _t.append('<span class="dashicons dashicons-search"></span>');
        }
      })
      $("nav ul li > ul").each(function () {
        var _t = $(this);

        $(this).children(":first").css("margin-top", topNav);


        var size_total_items_height = 0;
        _t.children().each(function () {
          var _t2 = $(this);
          size_total_items_height += _t2.outerHeight();
        });

        $(this).children().eq(0).css("margin-top", topNav);
      });


      // SETTING UP THE FOOTER MOUSE OVER EVENTS
      $("footer a").mouseover(footerOver).mouseout(footerOut);
      $(".email a").mouseover(emailOver).mouseout(emailOut);

      // SETTING UP THE BLOG SEARCH BAR
      $("#search-submit").each(function () {

        $(this).mouseover(submitOver).mouseout(submitOut).click(function (event) {

          event.stopPropagation();
          event.preventDefault();

        });

      });

      $(".royale-form").each(function () {

        $(this).attr("action", "");

      });


      $("#search-bar").each(function () {

        var ths = $(this);

        $(this).find("#search-field").each(function () {

          if ($(this).attr("value")) {

            $(this).data("parent", ths).data("original", $(this).attr("value")).focus(inFocus).blur(outFocus);

          }

        });

      });


      if (window.royale_settings.enable_ajax == 'on') {
        var ajax = require('./jsinc/_ajax');

        ajax.ajax_init({
          main_settings: window.royale_settings,
          action_reinit: reinit,
          action_check_if_we_can_load_new_page: ajax_check_if_we_can_remove_loading,
          action_reinit_all_loaded: ajax_reinit_all_loaded,
        });
      }

      // -- END ajax_init()


      royale_check_is_ready();

    }

    function ajax_reinit_all_loaded() {

      setTimeout(function () {

        if (window.dzscsc_init) {
          dzscsc_init('.contentscroller.auto-init', {init_each: true})
        }
        setTimeout(function () {
          $('.contentscroller').each(function () {
            var _t3 = $(this);
            _t3.get(0).api_force_resize();
          })
        }, 100);

      }, 500);
    }

    function ajax_check_if_we_can_remove_loading($_tempContentToBeAdded, argfunc) {

      if ($_tempContentToBeAdded.find('.theme-background--actual').eq(0) && $_tempContentToBeAdded.find('.theme-background--actual').eq(0).css('background-image')) {


        var img_src = sanitize_css_background_image($_tempContentToBeAdded.find('.theme-background--actual').eq(0).css('background-image'));
        check_when_img_is_ready_then_call_func(img_src, argfunc);
      } else {
        argfunc();
      }
    }

    function check_when_img_is_ready_promise(img_src) {
      return new Promise(resolve => {

        var img = new Image();
        var inte = 0;
        var intt = 0;
        img.onload = function () {

          clearInterval(inte);
          clearTimeout(intt);
          resolve(img);
        };

        img.src = img_src;

        inte = setInterval(() => {
          if (img.naturalWidth) {

            clearInterval(inte);
            clearTimeout(intt);
            royale_is_ready();
          }
        }, 100);

        intt = setTimeout(() => {
          clearInterval(inte);
          clearTimeout(intt);
          resolve();
        }, 3000);
      });
    }

    async function check_when_img_is_ready_then_call_func(img_src) {
      await check_when_img_is_ready_promise(img_src);
    }

    function royale_check_is_ready() {

      if (_body.find('.theme-background--actual').length) {
        var img_src = sanitize_css_background_image(_body.find('.theme-background--actual').eq(0).css('background-image'));
        check_when_img_is_ready_then_call_func(img_src).then(() => {
          royale_is_ready();
        });

        var img = new Image();
        img.onload = function () {
          royale_is_ready();
        };

        img.src = img_src;
      } else {
        royale_is_ready();
      }
    }

    function royale_is_ready() {

      setTimeout(function () {

        _body.addClass('royale-ready');
      }, 10);
    }

    function reinit($_tempContentToBeAdded) {

      if ($_tempContentToBeAdded && $_tempContentToBeAdded.find('.theme-background--actual').length) {

        _royaleBackgroundCon.append('<div class="theme-background--next royale--background" style="background-image: url(' + sanitize_css_background_image($_tempContentToBeAdded.find('.theme-background--actual').eq(0).css('background-image')) + ')" ;=""></div>');

        royale_fade_backgrounds();
      }

    }

    function royale_fade_backgrounds() {

      setTimeout(() => {

        _royaleBackgroundCon.addClass('transitioning-next');
        setTimeout(() => {

          _royaleBackgroundCon.find('.theme-background--actual').remove();
          _royaleBackgroundCon.find('.theme-background--next').addClass('theme-background--actual').removeClass('theme-background--next');

          _royaleBackgroundCon.removeClass('transitioning-next');
        }, 500);
      }, 1000);
    }

    function sanitize_css_background_image(arg) {
      arg = String(arg).replace(/url\(/g, '');
      arg = String(arg).replace(/\)/g, '');
      arg = String(arg).replace(/\"/g, '');

      return arg;
    }


    // FOOTER LINK OVER
    function footerOver() {

      $(this).parent().addClass("bullet-over");

    }

    // FOOTER LINK OVER
    function footerOut() {

      $(this).parent().removeClass("bullet-over");

    }

    // FOOTER EMAIL OVER
    function emailOver() {

      $(this).parent().addClass("email-over");

    }

    // FOOTER EMAIL OVER
    function emailOut() {

      $(this).parent().removeClass("email-over");

    }


    // BLOG LINK OVER
    function blogCommentOver(event) {

      event.stopPropagation();

      $(this).data("text").addClass("blog-comment-over");

    }

    // BLOG LINK OUT
    function blogCommentOut(event) {

      event.stopPropagation();

      $(this).data("text").removeClass("blog-comment-over");

    }

    // BLOG LINK CLICK
    function gotoBlogPage(event) {

      event.stopPropagation();

      window.location = $(this).data("url");

    }

    // COMMENTS LINK CLICK
    function jumpToComments(event) {

      event.stopPropagation();

      window.location = "#replies";

    }

    // SEARCH BAR FOCUS IN
    function inFocus() {

      var st = this.value;

      if (st === $(this).data("original")) this.value = "";

      $(this).addClass("form-field-focus");
      $(this).data("parent").addClass("search-field-focus");

    }

    // SEARCH BAR FOCUS OUT
    function outFocus() {

      if (this.value === "") this.value = $(this).data("original");

      $(this).removeClass("form-field-focus");
      $(this).data("parent").removeClass("search-field-focus");

    }

    // SEARCH BAR SUBMIT BUTTON OVER
    function submitOver(event) {

      event.stopPropagation();

      $(this).css("opacity", 0.75);

    }

    // SEARCH BAR SUBMIT BUTTON OUT
    function submitOut(event) {

      event.stopPropagation();

      $(this).css("opacity", 1);

    }

  }

})(jQuery);


jQuery(document).ready(function ($) {
  $.royale();
});







